import { useQuery } from '@tanstack/react-query';

import { useParams } from 'react-router-dom';
import { useAccessToken } from '../../../auth/AccessTokenContext';
import { getApiV1DownloadsAnalogueModelsByIdComputeCaseByComputeCaseId } from '../../../api/generated';
import { queryKeys } from '../../../hooks/queryKeys';

export const useFetchLog = (computeCaseId: string) => {
  const { modelId } = useParams();
  const token = useAccessToken();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: queryKeys.computeCaseLog(modelId as string, computeCaseId),
    queryFn: () =>
      getApiV1DownloadsAnalogueModelsByIdComputeCaseByComputeCaseId({
        path: { id: modelId as string, computeCaseId: computeCaseId as string },
      }),
    enabled: !!token,
  });

  return query;
};
